import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline';
import { DataGrid, RowsProp, ColDef, RowData } from '@material-ui/data-grid';
import { useLocation } from 'react-router-dom';
import { aceCSV } from './csv/modelB1hss';
import { sdoCSV } from './csv/modelSDOhss';

function convertCSVToJSON(str: string, delimiter = ','): RowsProp {
	const titles: string[] = str.slice(0, str.indexOf('\n')).split(delimiter);
	const rows: string[] = str.slice(str.indexOf('\n') + 1).split('\n');
	let ii: number = 0;
	let r: RowsProp = rows.map((row) => {
		const values = row.split(delimiter);
		const str: RowData = titles.reduce(
			(object, curr, i) => {
				let t: { [k: string]: any } = {};
				t[curr] = values[i];
				return { ...object, ...t, ...{ id: ii++ } };
			},
			{ id: 0 }
		);
		return str;
	});

	return r;
}

const columns: ColDef[] = [
	{ field: 'start_date', headerName: 'Start date', width: 250 },
	{ field: 'end_date', headerName: 'End date', width: 250 },
	{ field: 'max_date', headerName: 'Date of maximum speed', width: 250 },
	{ field: 'max_speed', headerName: 'Maximum speed', width: 220 }
];

const useStyles = makeStyles((theme) => ({
	root: {
		justifySelf: 'center',
		flexGrow: 1,
		width: 1000,
		backgroundColor: theme.palette.background.paper
	}
}));

function TabPanel(props: any) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`wrapped-tabpanel-${index}`}
			aria-labelledby={`wrapped-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={3}>{children}</Box>}
		</div>
	);
}

type PropsType = {
	lang: string | null;
};

const MyTabs = (props: PropsType) => {
	let rowsAce: RowsProp = convertCSVToJSON(aceCSV);
	let rowsSDO: RowsProp = convertCSVToJSON(sdoCSV);
	let { lang } = props;
	const classes = useStyles();
	const [ value, setValue ] = React.useState('ace');
	const labels = {
		ace: {
			ru: 'Cобытия прихода высокоскоростных потоков солнечного ветра, рассчитанные по данным с КА АСЕ',
			en: 'Events of the arrival of high-speed solar wind streams, calculated from the measurements on the ACE spacecraft'
		},
		sdo: {
			ru:
				'Cобытия прихода высокоскоростных потоков солнечного ветра, спрогнозированные по площадям корональных дыр с SDO/AIA',
			en:
				'Events of the arrival of high-speed solar wind streams, obtained from the solar wind speed forecast based on coronal holes areas observed in the SDO / AIA images'
		}
	};

	const handleChange = (event: any, newValue: string) => {
		setValue(newValue);
	};

	if (lang !== 'ru' && lang !== 'en') lang = 'ru';

	return (
		<div className={classes.root}>
			<Tabs value={value} onChange={handleChange} aria-label="wrapped label tabs example" variant="fullWidth">
				<Tab
					value="ace"
					label={lang === 'ru' ? labels.ace.ru : labels.ace.en}
					id="wrapped-tab-ace"
					aria-controls="wrapped-tabpanel-ace"
				/>
				<Tab
					value="sdo"
					label={lang === 'ru' ? labels.sdo.ru : labels.sdo.en}
					id="wrapped-tab-sdo"
					aria-controls="wrapped-tabpanel-sdo"
				/>
			</Tabs>
			<TabPanel value={value} index="ace">
				<div style={{ height: 800, width: 995 }}>
					<DataGrid rows={rowsAce} columns={columns} pageSize={50} />
				</div>
			</TabPanel>
			<TabPanel value={value} index="sdo">
				<div style={{ height: 800, width: 995 }}>
					<DataGrid rows={rowsSDO} columns={columns} pageSize={50} />
				</div>
			</TabPanel>
		</div>
	);
};

function useQuery() {
	return new URLSearchParams(useLocation().search);
}

export default function App() {
	const query = useQuery();

	return (
		<ScopedCssBaseline>
			<MyTabs lang={query.get('lang')} />
		</ScopedCssBaseline>
	);
}
